import React, { FunctionComponent } from 'react'
import { Path, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export type ThinArrowIconProps = {
  size?: number
  fillColor?: string
  testID?: string
}

export const ThinArrowIcon: FunctionComponent<ThinArrowIconProps> = ({ size = 24, fillColor, testID }) => {
  const { colors } = useTheme()
  const strokeColor = fillColor || colors.iconDefault

  return (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' testID={testID}>
      <Path
        d='M4 12L20 12M20 12L13.5 5.5M20 12L13.5 18.5'
        stroke={strokeColor}
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Svg>
  )
}
